import React, { useEffect } from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import PageHeader from '../components/PageHeader';
import CruisesPage from '../components/CruisesPage';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import SEO from '../components/SEO';

const PageContainer = styled.div`
  background-color: #efefef;
  min-height: 100vh;
`;

const TitleSection = styled.div`
  background-color: #ededed;
  padding: 29px 0;
  
  @media (max-width: 479px) {
    padding: 26px 0;
  }
`;

const TitleContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const MainTitle = styled.h1`
  color: #343434;
  font-size: 42px;
  font-family: 'Geologica', Arial, sans-serif;
  font-weight: 700;
  
  @media (max-width: 479px) {
    font-size: 25px;
  }
`;

const Cruises = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "TravelAgency",
    "name": "Максимум Тур - Круизы",
    "description": "Речные и морские круизы от турагентства Максимум Тур. Путешествия по рекам и морям на комфортабельных судах.",
    "touristType": [
      "Индивидуальные туристы",
      "Групповые туры",
      "Семейный отдых"
    ]
  };

  return (
    <PageContainer>
      <SEO 
        title="Круизы | Максимум Тур - Речные и морские круизы из Владивостока"
        description="Речные и морские круизы от турагентства Максимум Тур. Путешествия по рекам и морям на комфортабельных судах. Лучшие маршруты, комфорт и сервис."
        keywords="круизы, речные круизы, морские круизы, путешествия на судне, туры по воде, Максимум Тур, Владивосток"
        type="website"
        structuredData={structuredData}
      />
      <Menu />
      <Header />
      <PageHeader />
      <TitleSection>
        <TitleContainer>
          <MainTitle>Наши круизы</MainTitle>
        </TitleContainer>
      </TitleSection>
      <CruisesPage />
      <ContactForm />
      <Footer />
    </PageContainer>
  );
};

export default Cruises;
